export const defaultTheme = {
    "colorSettings": {
        "primary": "#004780",
        "secondary": "#00a1c0",
        "primaryLight": "#e1e9f0",
        "info": "#3b5762"
    }
};

export const fileNameLimit = 50;

export const allowedFileTypes = ["image/jpeg", "image/png", "image/gif"];

export const deviceImagesAllowedTypes = ["image/jpeg", "image/png"];

export const logoSizes = {
    large: 'largeImage',
    small: 'smallImage'
};

export const logoResolutions = {
    large: {
        width: 133,
        height: 48
    },
    small: {
        width: 39,
        height: 48
    }
};
